"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        flexShrink: 0,
        position: 'relative',
        width: '100%',
        height: 'auto'
    },
    avatar: {
        position: 'relative',
        '&[data-has-border=true]': {
            padding: 1
        }
    }
};
//# sourceMappingURL=avatar.group.style.js.map